import Component from '@glimmer/component';

export default class MwEventTabs extends Component {

}
